module.exports = __webpack_public_path__ + "img/call-fowarding.2966de88.png";